import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";
import ModuleQuestion from "../../components/ModuleQuestion";

const Module301 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">3.0.1 Case 1</h1>
            <p className="me-4">Estimated time to complete: 3-5 minutes</p>
          </section>
          <ModuleQuestion
            correctAnswer="A"
            assessmentName="self_assessment_101"
            videoTranscript={
              <>
                <p>
                  <strong>AUDIO</strong>
                  <br />
                  VO: (FEMALE)
                  <br />
                  This is self-assessment case number 101. This is a positive
                  scan. The size and contrast have already been adjusted, and
                  the normal cerebellar gray-white contrast can be seen here.
                  This is a difficult case, as there are areas of normal
                  gray-white contrast throughout the scan. However, in this
                  particular image, it is clear that there is loss of gray-white
                  contrast in the left temporal. Moving upwards, we can also see
                  that there is loss of gray-white contrast on the right,
                  extending into the occipital lobe on the right, as well as in
                  the left occipital lobe, here. Therefore, there are two
                  regions where there is loss of gray-white contrast. As we
                  continue moving upwards, we enter into the parietal region,
                  where there is loss of gray-white contrast in the anterior
                  aspect, as well as posteriorly. Furthermore, as we go towards
                  the top of the head, we can clearly see that there is
                  increased uptake in the medial parietal region. This area is
                  called the precuneus, and if we utilize the sagittal image, we
                  can see that there is increased activity throughout the
                  precuneus. Moving to the coronal images, you can also see that
                  there is increased activity extending to the periphery and
                  within gray matter. Therefore, there are at least three
                  regions where there is loss of gray-white contrast—the
                  temporal, occipital, and parietal regions. This scan is
                  positive for moderate to frequent amyloid neuritic plaques.
                </p>
              </>
            }
            previousLesson="/module-3/module-3-0-0"
            nextLesson="/module-3/module-3-0-2"
            iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_2077803959&entry_id=1_vhngmxu8&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
            questionType="assessment"
            videoId="1_vhngmxu8"
          />
        </main>
      </div>
    </div>
  );
};

export default Module301;
